import React from 'react'
import { FormattedMessage } from 'react-intl'

import { GlobalStyle } from './GlobalStyle'

export const RaineSquareDirectoryHeader = () => (
  <>
    <GlobalStyle />
    <div className="mb-2 text-foreground my-body-md">
      <FormattedMessage defaultMessage="WELCOME TO RAINE SQUARE" id="Q8MXhU" />
    </div>
    <div className="mb-4 my-heading-2xl">
      <FormattedMessage defaultMessage="Reclaim Your Lunch Break" id="s0l2ZI" />
    </div>
    <div className="mb-6 flex justify-center my-label-md">
      <FormattedMessage
        defaultMessage="Order a selection* of food and drinks online"
        id="jZICaj"
      />
    </div>
    <div className="mb-6 flex justify-center my-body-sm">
      <FormattedMessage
        defaultMessage="*Participating dining tenants."
        id="7aS4FL"
      />
    </div>
  </>
)
